<template>
    <ReserveCancel />
</template>

<script>
import ReserveCancel from "@/components/ReserveCancel.vue";

export default {
    name: 'ReserveCancelView',
    components: {
        ReserveCancel
    }
}
</script>